/**
 * Extract template ID from URL.
 *
 * Examples:
 * /casual_dining/preview
 * -> casual_dining
 *
 * /90386da0-8031-4785-9fe6-b643474b86a5/preview/edit
 * -> pizza (fallback)
 */
export const getTemplateIdFromUrl = (): string => {
  const pathname = window.location.pathname;
  const pathSegments = pathname.split("/").filter(Boolean);

  if (pathSegments.length === 0) {
    return "pizza";
  }

  const firstSegment = pathSegments[0];

  // If first segment is a UUID, it's restaurant ID, not template ID
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  if (uuidRegex.test(firstSegment)) {
    return "pizza";
  }

  return firstSegment;
};

/**
 * Extract restaurant ID from URL.
 *
 * Example:
 * /90386da0-8031-4785-9fe6-b643474b86a5/preview/edit
 *
 * -> 90386da0-8031-4785-9fe6-b643474b86a5
 */
export const getRestaurantIdFromUrl = (): string | null => {
  const pathname = window.location.pathname;
  const pathSegments = pathname.split("/").filter(Boolean);

  if (pathSegments.length === 0) {
    return null;
  }

  const firstSegment = pathSegments[0];

  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return uuidRegex.test(firstSegment) ? firstSegment : null;
};
